export const STATUSES = {
  OPEN:        'open',
  SCHEDULED:   'scheduled',
  CLOSED:      'closed',
  IN_PROGRESS: 'in-progress'
}